import { ReactElement } from 'react';
import { Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import {
  AppFormikDatePicker,
  AppFormikSelectWithKeys,
} from 'shared/components/AppComponents';

const PolicyReviewCard = (): ReactElement => (
  <Paper variant="outlined" className="policy-information-card">
    <Typography variant="h6">Review Schedule</Typography>
    <Typography className="mt-2">
      Set when this policy should be reviewed
    </Typography>
    <Grid container className="policy-grid">
      <Grid item md={6} xs={12}>
        <Stack>
          <AppFormikDatePicker
            disableToday
            autoFocus
            fullWidth
            className="mb-1"
            name="reviewDate"
            testid="datepicker-dropdown"
            InputProps={{
              name: 'reviewDate',
              'aria-labelledby': 'duedate-label',
              notched: false,
            }}
            label="Review Date"
            outerLabel
            placeholder="gg/mm/aaaa"
            renderInput={(props: any) => (
              <TextField {...props} fullWidth margin="normal" />
            )}
          />
          <Typography component="span">
            Optional: Set a specific date when this policy should be reviewed.
            Leave blank if no review is needed.
          </Typography>
        </Stack>
      </Grid>
      <Grid item md={6} xs={12}>
        <AppFormikSelectWithKeys
          name="reviewIntervalMonths"
          className="rework-selection"
          notched={false}
          labelId="fix-selection-label"
          testid="solicitor-dropdown"
          MenuProps={{
            className: 'menu-fix-selection single-fix-rework',
          }}
          outerLabel
          placeholder="Select Interval"
          notEmphasized
          notSelectablePlaceholder
          label="Review Interval (Optional)"
          titleKey="title"
          valueKey="value"
          items={[
            { title: 'No Automatic Review', value: 0 },
            { title: '3 Months', value: 3 },
            { title: '6 Months', value: 6 },
            { title: '12 Months', value: 12 },
            { title: '24 Months', value: 24 },
            { title: '36 Months', value: 36 },
          ]}
        />

        <Typography className="info-text mt-2">
          Optional: Set how often this policy should be automatically reviewed.
          Choose "No automatic review" if you only want to set a specific review
          date.
        </Typography>
      </Grid>
    </Grid>
  </Paper>
);

export default PolicyReviewCard;
